import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import axios from "axios";
import { baseUrl } from "./baseUrl"; // Ensure baseUrl is correctly imported

export default function Profile(props) {
  const [workingStates, setWorkingStates] = useState([]);
  const [selectedWorkingState, setSelectedWorkingState] = useState(
    localStorage.getItem("selectedWorkingStateId") || ""
  );

  console.log(selectedWorkingState,'.................................')
  const [message, setMessage] = useState(""); // For success/error messages
  const [loading, setLoading] = useState(false); // For button loading state



  // Fetch working states
  const getWorkingStates = async () => {
    try {
      const response = await axios.get(baseUrl + "Apicontroller/working_state_get");
      if (response.data.status === 200) {
        const tempArray = response.data.data.map((state) => ({
          label: state.state,
          value: state.state_id,
        }));
        console.log(response, 'this is ther reseppp');
        
        setWorkingStates(tempArray);
      } else {
        setMessage("Failed to fetch working states.");
      }
    } catch (error) {
      console.error("Error fetching working states:", error);
      setMessage("Error fetching working states.");
    }
  };

  // Update working state
const updateWorkingState = async () => {
  setLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}Users/update_working_state_id/${selectedWorkingState}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("supremetech_authentication"),
        },
      }
    );
    console.log(`${baseUrl}Apicontroller/Users/update_working_state_id/${selectedWorkingState}`,
      '//////////////////////////////////////');
    
    const result = await response.json();

    if (result?.status === 200) {
      localStorage.setItem("selectedWorkingStateId", selectedWorkingState);
      setMessage("Working state updated successfully!");
    } else {
      setMessage(result.message || "Failed to update working state.");
    }
  } catch (error) {
    console.error("Error updating working state:", error);
    setMessage("Error updating working state.");
  } finally {
    setLoading(false);
  }
};






  // Handle working state change
  const handleWorkingStateChange = (e) => {
    setSelectedWorkingState(e.target.value);
    console.log(e.target.value, 'this is the selected working state id for updates');
    console.log(localStorage.getItem("user_token"), 'this is tha uth');
    
  };

  // Clear message after a few seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  // Authentication check & fetch working states
  useEffect(() => {
    const authentication = localStorage.getItem("supremetech_authentication");
    const phone = localStorage.getItem("supremetech_phone");
    if (!authentication || !phone) {
      props.history.push("/");
    }
    getWorkingStates();
  }, []);

  if (
    localStorage.getItem("supremetech_authentication") &&
    localStorage.getItem("supremetech_phone")
  ) {
    return (
      <div className="container pt-5 pt-lg-5 mt-md-5 mt-4">
        <div className="row heading-div">
          <div className="col-md-12 text-center">
            <h1 className="heading">My Account</h1>
          </div>
        </div>
        <div className="main-body">
          <div className="row gutters-sm">
            <div className="col-md-8">
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Full Name</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {localStorage.getItem("supremetech_name")}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Phone</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {localStorage.getItem("supremetech_phone")}
                    </div>
                  </div>
                  <hr />
                  {localStorage.getItem("email") && (
                    <>
                      <div className="row">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Email</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          {localStorage.getItem("email")}
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                  {localStorage.getItem("company_name") && (
                    <>
                      <div className="row">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Company Name</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          {localStorage.getItem("company_name")}
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Working State</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      <select
                        name="working_state_id"
                        className="form-control"
                        value={selectedWorkingState}
                        onChange={handleWorkingStateChange}
                      >
                        <option value="" disabled>
                          Select Working State
                        </option>
                        {workingStates.map((state, index) => (
                          <option key={index} value={state.value}>
                            {state.label}
                          </option>
                        ))}
                      </select>
                      <button
                        className="btn btn-primary mt-2"
                        style={{ background: "#dc3545", color: "white" }}
                        onClick={updateWorkingState}  
                        disabled={!selectedWorkingState || loading}
                      >
                        {"Update Working State"}
                        
                        
                      </button>
                    </div>
                  </div>
                  {message && (
                    <div className="row mt-3">
                      <div className="col-sm-12">
                        <p style={{ color: message.includes("Error") ? "red" : "green" }}>
                          {message}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <Redirect to="/register" />;
  }
}
